import { BrandProps, brandStyles, brandContainerStyles } from '@kite_aerolab/shared/components';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import Brands from '@kite_aerolab/shared/assets/brands'

@Component({
  selector: 'kite-brand',
  template: `
    <div [ngClass]="brandContainer">
      <div #svgContainer
        (click)="onClick.emit($event)"
        [ngClass]="brand"
        [ngStyle]="getStyles()"
        [attr.aria-label]="ariaLabel"
      >
      </div>
    </div>
  `,
})
export class BrandComponent implements AfterViewInit {
  @ViewChild("svgContainer") svgContainer: ElementRef;

  /**
   * CSS del ícono
   */
  @Input() class: string;
  /**
   * CSS del ícono
   */
  @Input() css: BrandProps['css'];
  /**
   * Nombre del ícono
   */
  @Input() name: BrandProps['name'];

  /**
   * Ancho de la marca
   */
  @Input() width: BrandProps['width'];
  /**
   * Alto de la marca
   */
  @Input() height: BrandProps['height'];
  /**
   * Optional click handler
   */
   @Output() onClick: EventEmitter<any> = new EventEmitter();
  /**
   * Aria Label
   */
  @Input('aria-label') ariaLabel = '';

  public get brandContainer(): string[] {
    return [
      brandContainerStyles({}).className
    ]
  }
  public get brand(): string[] {
    return [
      brandStyles({
        css: this.css,
      }).className,
    ];
  }

  getStyles() {
    const obj = {};
    if (this.width) {
      obj['width.px'] = this.width;
      if (!this.height) {
        obj['height'] = 'auto';
      }
    }
    if (this.height) {
      obj['height.px'] = this.height;
      if (!this.width) {
        obj['width'] = 'auto';
      }
    }
    return obj;
  }

  appendSVG(svg = '') {
    if (this.svgContainer)
      this.svgContainer.nativeElement.innerHTML = svg;
  }

  ngAfterViewInit() {
    this.appendSVG(Brands[this.name ?? '']);
  }
}
